// action types
const BOOK_UPDATE = "bookUpdate";

//action creator
export const bookUpdate = (book) => {
  return {
    type: BOOK_UPDATE,
    payload: book,
  };
};

// reducer
export const updateBookReducer = (state = null, action) => {
  if (action.type === BOOK_UPDATE) {
    return action.payload;
  } else {
    return state;
  }
};
